import { z } from 'zod';
import type { Capabilities } from '../types/workspace.types';

/**
 * The wire contract for `GET /api/v1/capabilities`.
 *
 * `projectWorkspace` and `projectDocuments` have been in the response since the route
 * existed, so they are required. Flags added later default to off, which is what an older
 * deployment that does not send them actually supports.
 */
const uploadLimitSchema = z.object({
  documentType: z.string(),
  extensions: z.array(z.string()),
  maxSizeBytes: z.number().int().positive(),
});

export const capabilitiesSchema = z.object({
  projectWorkspace: z.boolean(),
  projectDocuments: z.boolean(),
  documentTypes: z.array(z.string()).default([]),
  uploadLimits: z.array(uploadLimitSchema).default([]),
  partSizeBytes: z.number().int().positive(),
  mergeModelRequests: z.boolean().default(false),
  modelFileMaxSizeBytes: z.number().int().nonnegative().default(0),
  assistant: z.boolean().default(false),
  projectSummary: z.boolean().default(false),
  projectHealth: z.boolean().default(false),
  projectAudits: z.boolean().default(false),
  projectDetails: z.boolean().default(false),
});

/** A Core deployment that predates the capabilities route supports none of these. */
export const NO_CAPABILITIES: Capabilities = {
  projectWorkspace: false,
  projectDocuments: false,
  documentTypes: [],
  uploadLimits: [],
  partSizeBytes: 0,
  mergeModelRequests: false,
  modelFileMaxSizeBytes: 0,
  assistant: false,
  projectSummary: false,
  projectHealth: false,
  projectAudits: false,
  projectDetails: false,
};

export function toCapabilities(raw: z.output<typeof capabilitiesSchema>): Capabilities {
  return raw;
}
